import { render } from "./CardRight.vue?vue&type=template&id=79d58e86&scoped=true"
import script from "./CardRight.vue?vue&type=script&lang=js"
export * from "./CardRight.vue?vue&type=script&lang=js"

import "./CardRight.vue?vue&type=style&index=0&id=79d58e86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79d58e86"

export default script